import { IGroupResult } from 'src/app/models/proxy-group';
import { createAction, props } from '@ngrx/store';

export const GetGroupsApiAction = createAction('[Proxy-Group] - Get Proxy Groups');

export const SuccessGetProxyGroupsApiAction = createAction(
  '[Proxy-Group] - Success Get Proxy Group',
  props<{ groupObj: IGroupResult }>()
);

export const ErrorGetProxyGroupsApiAction = createAction('[Proxy-Group] - Error', props<Error>());

export const SetProxyGroupObjectAction = createAction(
  '[Proxy-Group] - Set Proxy Group Object',
  props<{ groupObj: IGroupResult }>()
);

export const ClearProxyGroupObjectAction = createAction(
  '[Proxy-Group] - Clear Proxy Group Object'
);
